module.exports = __webpack_public_path__ + "img/3.07.thmb.xs.9072769b.jpg";